import axios from 'axios'

// Create axios instance with default config
const api = axios.create({
  // Use VITE_API_URL when provided (e.g. CI/deploy). Default to a relative
  // `/api` so requests are same-origin and avoid CORS issues behind the
  // reverse proxy in production.
  baseURL: import.meta.env.VITE_API_URL || '/api',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: true, // Required for cookie-based auth
  // Note: We manually handle CSRF tokens in the request interceptor below
})

// Request interceptor to add auth token and CSRF token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth-token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    
    // Manually extract XSRF-TOKEN from cookies and add as header
    const csrfToken = getCookieValue('XSRF-TOKEN')
    if (csrfToken) {
      config.headers['X-XSRF-TOKEN'] = decodeURIComponent(csrfToken)
    } else {
      console.warn('⚠️ No XSRF-TOKEN cookie found for request:', config.url)
    }
    
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Helper function to get cookie value by name
function getCookieValue(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  const cookieValue = parts.length === 2 ? parts.pop().split(';').shift() : null;
  return cookieValue;
}

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('auth-token')
      localStorage.removeItem('auth-storage')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default api
